import { Text, TextProps, useDisclosure } from "@chakra-ui/react"
import { useRef } from "react"
import { useIsOverflow } from "../../common/hooks/useIsOverflow"
import CustomTooltip from "./CustomTooltip"

type Props = TextProps & {
  text: string
}

const OverflowingText = ({ text, noOfLines = 2, fontSize = "sm", textAlign = "center" }: Props) => {
  /* This makes a controlled tooltip so it shows on touch on mobile */
  const { isOpen, onOpen, onToggle, onClose } = useDisclosure()
  const textRef = useRef(null)
  const isOverflow = useIsOverflow(textRef)

  return (
    <CustomTooltip label={isOverflow ? text : ""} maxW="100vw" isOpen={isOpen}>
      <Text
        fontSize={fontSize}
        textAlign={textAlign}
        noOfLines={noOfLines}
        zIndex="tileContent"
        ref={textRef}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        onClick={onToggle}
      >
        {text}
      </Text>
    </CustomTooltip>
  )
}

export default OverflowingText
